// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"RemoveExport_wrapperComponent__Yijrs","actions":"RemoveExport_actions__yKtuV"};